import { UpdateUserPermission } from "../../dtos/role/updateUserPermission";
import { CreatePermissionByUserInputDto } from "../../dtos/role/CreatePermissionByUserIdInputDto";
import { CreatePermissionInputDto } from "../../dtos/role/CreatePermissionInputDto";
import { GetPermissionByRoleAndUserDto } from "../../dtos/role/GetPermissionByRoleAndUserDto";
import { get, post } from "../../utils/BaseService";

export async function getPermissionByRole(dispatch: any, roleId: any) {
  return await get(dispatch, "/permission/getAllPermissionByRole", roleId);
}

export async function createPermissionByRoleId(
  dispatch: any,
  input: CreatePermissionInputDto
) {
  return await post(dispatch, "/permission/createPermissionByRoleId", input);
}
export async function createPermissionByUserId(
  dispatch: any,
  input: CreatePermissionByUserInputDto
) {
  return await post(dispatch, "/permission/createPermissionByUserId", input);
}
export async function getPermissionByUserAndRole(
  dispatch: any,
  input: GetPermissionByRoleAndUserDto
) {
  return await post(dispatch, "/permission/getPermissionByUserAndRole", input);
}
export async function updateUserPermission(
  dispatch: any,
  input: UpdateUserPermission
) {
  return await post(dispatch, "/permission/updateUserPermission", input);
}
export async function getPermissionByUserAndPermissionName(
  dispatch: any,
  input: UpdateUserPermission
) {
  return await get(dispatch, "/permission/getPermissionByUserAndPermissionName", input);
}
